//正则表达式 只能含有ATCGU，空格，换行 否则返回false
export const dnaSet = ["A", "T", "C", "G"];
export const proteinSet = ["A", "C", "D", "E", "F", "G", "H", "I", "K", "L", "M", "N", "P", "Q", "R", "S", "T", "V",
	"W", "Y"
];

export function spellConfirm(str) {
	var regex = /^[ATCGUatcgu \n]+$/;
	return (regex.test(str));
}


//将输入的多条序列加入数组
export function listBaseStr(str) {
	let listStr = str.toString().split(/[\s\n]/);
	for (let index = 0; index < listStr.length; index++) {
		listStr[index] = formatAlphaStr(listStr[index]);
	}
	return listStr.notempty();
}

//格式化序列去除逗号空格只包含（AGTCU）
export function formatBaseStr(str) {
	var regex = /[^ATCGUatcgu]/g;
	var result = str.replace(regex, '');
	result = result.toString().replace(/\s/g, '').trim();
	return result.toUpperCase();
}


//格式化序列英文序列
export function formatAlphaStr(str) {
	var regex = /[^a-zA-Z]/g;
	var result = str.replace(regex, '');
	result = result.toString().replace(/\s/g, '').trim();
	return result.toUpperCase();
}


//验证是否为数字
export function numberVerify(num) {
	if (num == '')
		return false;
	var regex = /^[0-9]*$/g;
	return regex.test(num);
}


//输出序列数组和其位置
export function getSeqArrayInfo(array) {
	var result = '';
	var unitLength = Number(0);
	var totalLength = Number(0);
	for (var i = 0; i < array.length; i++) {
		unitLength = array[i].length;
		result += "序列" + (i + 1) + ",位置从" + (totalLength + 1) + "至" + (unitLength + totalLength) + "\n" +
			array[i] + "\n";
		totalLength = totalLength + unitLength;
	}
	return result;
}


//自定义信息输出序列
// export function getSeqArrayInfoWithMsg(){
// 	var result = '';
// 	var unitLength = Number(0);
// 	var totalLength = Number(0);
// 	for (var i = 0; i < array.length; i++) {
// 		unitLength = array[i].length;
// 		result += "序列" + (i + 1) + ",位置从" + (totalLength + 1) + "至" + (unitLength + totalLength) + "<br>" +
// 			array[i] + "<br>";
// 		totalLength = totalLength + unitLength;
// 	}
// 	return result;
// }


//数组洗牌随机算法
Array.prototype.shuffle = function () {
	var array = this;
	let currentIndex = array.length;
	while (currentIndex) {
		let randomIndex = Math.floor(Math.random() * currentIndex);
		currentIndex--;
		let temp = array[currentIndex];
		array[currentIndex] = array[randomIndex];
		array[randomIndex] = temp;
	}
	return array;
}


//清空数组空值
Array.prototype.notempty = function () {
	var arr = [];
	this.map(function (val, index) {
		//过滤规则为，不为空串、不为null、不为undefined，也可自行修改
		if (val !== "" && val != undefined) {
			arr.push(val);
		}
	});
	return arr;
}


//数组升序排序算法 引用时不用加括号 直接arr.sort(arrSort);
export function arrSort(a, b) {
	return a - b;
};

//生成选定集集随机字母 传入选定字符集 和 要突变的基因（返回值不会是该基因）
export function getRandomLetter(letterArray, original) {
	var letterLength = letterArray.length;
	if (letterArray == 0)
		return null;
	var originalIndex = 0;
	var randomNum = Math.floor(Math.random() * letterLength);
	for (var index = 0; index < letterLength; index++) {
		if (letterArray[index] == original)
			originalIndex = index;
	}
	while (randomNum == originalIndex) {
		randomNum = Math.floor(Math.random() * letterLength);
	}
	return letterArray[randomNum];
}


//替换字符串中指定位置的字符
export function replaceChat(source, pos, newChar) {
	if (pos < 0 || pos >= source.length || source.length == 0) {
		return "invalid parameters...";
	}
	var iBeginPos = 0,
		iEndPos = source.length;
	var sFrontPart = source.substr(iBeginPos, pos);
	var sTailPart = source.substr(pos + 1, source.length);
	var sRet = sFrontPart + newChar + sTailPart;
	return sRet;
}


//KMP字符串匹配算法
//console.log(kmpGetStrPartMatchValue(t));//[0, 0, 0, 0, 1, 2, 0]
//console.log(KMP(s,t));//11
//next数组计算
export function kmpGetStrPartMatchValue(str) {
	var prefix = [];
	var suffix = [];
	var partMatch = [];
	for (var i = 0; i < str.length; i++) {
		var newStr = str.substring(0, i + 1);
		if (newStr.length == 1) {
			partMatch[i] = 0;
		} else {
			for (var k = 0; k < i; k++) {
				prefix[k] = newStr.slice(0, k + 1);
				suffix[k] = newStr.slice(-k - 1);
				if (prefix[k] == suffix[k]) {
					partMatch[i] = prefix[k].length;
				}
			}
			if (!partMatch[i]) {
				partMatch[i] = 0;
			}
		}
	}
	prefix.length = 0;
	suffix.length = 0;
	return partMatch;
};
//kmp算法主函数
export function KMP(sourceStr, targetStr) {
	var partMatchValue = kmpGetStrPartMatchValue(targetStr);
	var result = false;
	for (var i = 0; i < sourceStr.length; i++) {
		for (var m = 0; m < targetStr.length; m++) {
			if (targetStr.charAt(m) == sourceStr.charAt(i)) {
				if (m == targetStr.length - 1) {
					result = i - m;
					break;
				} else {
					i++;
				}
			} else {
				if (m > 0 && partMatchValue[m - 1] > 0) {
					m = partMatchValue[m - 1] - 1;
				} else {
					break;
				}
			}
		}
		if (result) {
			break;
		}
	}
	return result;
};
